import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import CommonCJAMiddleware from 'yoda-site-components/lib/middlewares/CommonCJAMiddleware';
import MiniPDPAnalyticsMiddleware from 'yoda-mini-pdp/lib/middlewares/MiniPDPAnalyticsMiddleware';
import MiniPDPCJAMiddleware from 'yoda-mini-pdp/lib/middlewares/CJAMiddleware';
import CheckoutMiddleWare from 'yoda-checkout-components/lib/middlewares/CheckoutAnalyticsMiddleware';
import AnalyticsMiddleware from './AnalyticsMiddleware';
import CJAMiddleware from './CJAMiddleware';
import PdpIrisMiddleware from './PdpIrisMiddleware';

const rootMiddleware = [
    CommonMiddleware,
    CommonCJAMiddleware,
    AnalyticsMiddleware,
    CJAMiddleware,
    MiniPDPCJAMiddleware,
    MiniPDPAnalyticsMiddleware,
    CheckoutMiddleWare,
    PdpIrisMiddleware,
];

export default rootMiddleware;
